export const getPostalCodeOutwardCodeForDataLayer = (
  postalCode: string,
  countryCode: string | undefined
) => {
  if (countryCode !== 'UK' && countryCode !== 'GB') {
    return postalCode;
  }
  return postalCode?.replace(/[^a-zA-Z0-9]/g, '')?.slice(0, -3) || postalCode;
};
